import { styled } from 'lib_ui-primitives';
import PropTypes from 'prop-types';
import { forwardRef, createElement as rc, useMemo } from 'react';
import useFormControl from '../../hooks/useFormControl';
import ScanTextInput from '../ScanTextInput';
import FormField from './FormField';

const StyledTextInput = styled(ScanTextInput)`
    flex-grow: 1;
`;

const _p = {
    useFormControl
};
export const _private = _p;

const ShortText = forwardRef(function ShortText(props, ref) {
    const {
        autoComplete = 'off',
        hNode,
        hNode: {
            id,
            max,
            maxLength,
            min,
            minLength,
            placeholder,
            pattern,
            propertyName,
            rows,
            treePosition: { sequence },
            required
        },
        multiline,
        type = 'textbox',
        onKeyPress,
        style
    } = props;

    const { autoFocus, title, value, setValue, disabled, errors, onBlur, onFocus, active } = _p.useFormControl(props);
    const isPinnedShortText = hNode.transforms?.some(t => t.hNodeType === 'DefaultToPreviousSelection');
    // When DefaultToPreviousSelection returns {} (no stored value yet), guard against
    // "[object Object]" appearing in the input by coercing objects to empty string.
    // useMemo ensures safeValue only changes when value changes (string primitives compare by value,
    // but this makes the intent explicit and safe for future changes).
    const safeValue = useMemo(() => value !== null && typeof value === 'object' ? '' : (value ?? ''), [value]);
    const fieldEmpty = safeValue === '';

    // prettier-ignore
    return rc(FormField, { hNode, title, errors, active, fieldEmpty, onBlur, noMaxWidth: multiline, required, style, disabled },
        rc(StyledTextInput, {
            hNode,
            active,
            ref,
            id,
            name: propertyName,
            type,
            disabled,
            autoComplete,
            spellCheck: false,
            max,
            maxLength,
            min,
            minLength,
            pattern,
            placeholder: active ? placeholder ?? '' : '',
            multiline,
            rows,
            value: safeValue,
            onKeyPress,
            onChange: setValue,
            onFocus,
            autoFocus,
            sequence,
            'aria-label': title,
            trailingIcon: isPinnedShortText ? 'star' : '',
            pinnedValue: isPinnedShortText
        })
    );
});
ShortText.propTypes = {
    hNode: PropTypes.shape({
        treePosition: PropTypes.shape({
            sequence: PropTypes.number.isRequired
        }).isRequired
    }).isRequired,
    autoComplete: PropTypes.string,
    multiline: PropTypes.bool,
    type: PropTypes.string,
    onKeyPress: PropTypes.func,
    onChange: PropTypes.func
};

export default ShortText;
